import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Point from './point'

import { points } from './points'

const SellingPoints: React.FunctionComponent = () => (
    <Container>
        {points.map((p, i) => <Point key={i} number={i} {...p} />)}
    </Container>
)

const Container = styled.div`
    display: grid;
    justify-content: center;
    grid-template-columns: 100%;

    grid-gap: 80px;

    padding: 50px 10px;

    ${up('mobileBig')} {
        padding: 80px 20px;
        grid-gap: 100px;
    }

    ${up('tablet')} {
       padding: 100px 129px;
    }

    ${up('desktop')} {
        padding: 100px 0;
    }
`

export default SellingPoints
